import {Component, Input} from '@angular/core';

@Component({
  selector: 'question',
  templateUrl: 'question.html',
  styleUrls: ['question.scss'],
})
export class QuestionComponent {

    @Input()
    public title: string;

    @Input()
    public description: string;

    @Input()
    public valueOnly: boolean = false;

}
